module.exports = __webpack_public_path__ + "static/media/cloud1.84476a6d.png";